import react, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import { Puff } from "react-loading-icons";
import EventTablesRequest from "./EventTablesRequest";
import FormTableReservation from "./_FormTableReservation";
import FormTableReservationInfo from "./_FormTableReservationInfo";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../../../../components/NavBar";

const EventTables = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    tables: [],
    event: {
      id: 0,
      name: "",
      id_venues: "",
    },
    modalFormTableReservation: {
      show: false,
      data: {
        table: {},
      },
    },
    modalFormTableReservationInfo: {
      show: false,
      data: {
        table: {},
      },
    },
  });

  useEffect(() => {
    document.title = "Event Tables | Nightspot Dashboard";
    getInfoEventTables();
  }, []);

  const getInfoEventTables = async (closeFormTableReservation = false) => {
    setIsLoading(true);
    let info = await EventTablesRequest.getInfoEventTables({
      id_events: params.id,
    });
    if (info && info.status) {
      setState(info.data);
    }
    setIsLoading(false);
  };

  const handlerActionTable = async (id) => {
    setIsLoading(true);
    let info = await EventTablesRequest.getInfoActionTable({
      id_events: params.id,
      id: id,
    });
    if (info && info.status) {
      if (info.data.table.status === "RESERVED") {
        setState({
          ...state,
          modalFormTableReservationInfo: {
            ...state.modalFormTableReservationInfo,
            show: true,
            data: info.data,
          },
        });
      } else if (info.data.table.status === "HOLD") {
        toast.error(
          "Esta mesa encontra-se em processo de pagamento. Poderá demorar até 6 minutos a desbloquear a mesma ou a passar a reservado",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          },
        );
        getInfoEventTables();
      } else {
        setState({
          ...state,
          modalFormTableReservation: {
            ...state.modalFormTableReservation,
            show: true,
            data: info.data,
          },
        });
      }
    }
    setIsLoading(false);
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const Tables = () => {
    return state.tables.map((item) => {
      return (
        <div
          className="col-6 col-md-3 mb-3"
          key={item.id}
          //temporary
          onClick={() => {
            if (item.status_text !== "Livre") {
              handlerActionTable(item.id);
            }
          }
          }
        >
          <div className="block-mesa h-100">
            <div
              className="block-content"
              style={{ borderLeft: `5px solid ${item.color}` }}
            >
              <div className="block-title">
                <h3>Mesa: {item.name}</h3>
              </div>
              <div className="block-details mt-3">
                {item.base_price}
                <i className="fa-solid fa-euro-sign ms-1 me-2"></i>
                <i className="fa-solid fa-users ms-2 me-1"></i>
                {item.numberOfGuests}
              </div>
            </div>
            <div className={`block-footer ${item.status.toLowerCase()}`}>
              <div className="ms-3">
                Estado: <span>{item.status_text}</span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/events/">Eventos</Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Gestor de Mesas
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-7">
                    <h2 className="dashboard-h2">
                      Evento: {state.event.name}{" "}
                      <small style={{ color: "#ea2c61" }}>|</small>{" "}
                      <small style={{ fontWeight: "100" }}>
                        {state.event.date_formated}
                      </small>
                    </h2>
                  </div>
                  <div className="col-12 col-sm-5 ">
                    <Link
                      className="btn btn-primary float-end ms-3"
                      to={`/my/events/${state.event.id}/tables/reservation-list`}
                    >
                      <i className="fa-solid fa-list"></i>&nbsp;Lista de
                      reservas
                    </Link>
                    <Link
                      className="btn btn-primary float-end ms-3"
                      to={`/my/events/${state.event.id}/tables/transactions-list`}
                    >
                      <i className="fa-solid fa-money-bill-transfer"></i>
                      &nbsp;Lista de pagamentos
                    </Link>
                    <Link
                      className="btn btn-primary float-end ms-3"
                      onClick={() => getInfoEventTables()}
                      to="#"
                    >
                      <i className="fa-solid fa-arrows-rotate"></i>&nbsp;
                    </Link>
                  </div>
                </div>
                <div className="row mt-3">
                  <Tables />
                </div>
              </>
            )}
          </div>
        </div>
        <FormTableReservation
          show={state.modalFormTableReservation.show}
          handleModalhide={() => getInfoEventTables(true)}
          info={state.modalFormTableReservation.data}
        />
        <FormTableReservationInfo
          show={state.modalFormTableReservationInfo.show}
          handleModalhide={() => getInfoEventTables(true)}
          info={state.modalFormTableReservationInfo.data}
        />
      </NavBar>
    </div>
  );
};

export default EventTables;
